export class ApiMobilephoneSearchAction {
  static readonly type = '[Api] Mobile phone search';
}

export class ApiMobilephoneFiltersAction {
  static readonly type = '[Api] Get mobile phone filters';
}
